import {
  IcreateBrandUserAPIBody,
  IcreateBrandUserAPIResponse,
  IdeleteBrandUserAPIResponse,
  IgetBrandUserProfileAPIResponse,
  IgetBrandUsersAPIResponse,
  IupdateBrandUserAPIBody,
  IupdateBrandUserAPIResponse,
  IupdateRoleAPIResponse,
} from 'api/endpoints/brandUsers/brandUsers.response.interface';
import { getBasePath } from '../../utils/config';
import { safeJsonParse, buildUrl } from 'api/utils/fetchHelpers';

export const getBrandUsersAPI = async ({
  clientId,
  token,
}: {
  clientId: string;
  token: string;
}): Promise<IgetBrandUsersAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/client_profile/get_client_users`, { client_id: clientId }),
    params
  );
  return await safeJsonParse(response);
};

export const getBrandUserProfileAPI = async ({
  userId,
  token,
}: {
  userId: string;
  token: string;
}): Promise<IgetBrandUserProfileAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/user/get_user_profile`, { user_id: userId }),
    params
  );
  return await safeJsonParse(response);
};

export const createBrandUserAPI = async ({
  body,
  token,
}: {
  body: IcreateBrandUserAPIBody;
  token: string;
}): Promise<IcreateBrandUserAPIResponse> => {
  const params = {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/user/createUser`, params);
  return await safeJsonParse(response);
};

export const updateBrandUserAPI = async ({
  body,
  token,
}: {
  body: IupdateBrandUserAPIBody;
  token: string;
}): Promise<IupdateBrandUserAPIResponse> => {
  const params = {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/user/update_user`, params);
  return await safeJsonParse(response);
};

export const deleteBrandUserAPI = async ({
  userId,
  token,
}: {
  userId: string;
  token: string;
}): Promise<IdeleteBrandUserAPIResponse> => {
  const params = {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/user/delete_user`, { user_id: userId }),
    params
  );
  return await safeJsonParse(response);
};

export const updateRoleAPI = async ({
  user_id,
  role,
  prev_role,
  token,
}: {
  user_id: string;
  role: string;
  prev_role: string;
  token: string;
}): Promise<IupdateRoleAPIResponse> => {
  const params = {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      user_id: user_id,
      role: role,
      prev_role: prev_role,
    }),
  };
  const response = await fetch(`${getBasePath()}/user/assign_role`, params);
  return await safeJsonParse(response);
};
